import * as React from 'react';
import { useSelector } from 'react-redux';

import { orgUsageSelector } from '../../../redux/app/selectors/organization';

export const TotalUsage = () => {
  const usage = useSelector(orgUsageSelector);

  return (
    <div style={{marginTop: '2.5px'}}>
      <p className="fsz-11 bold-800 uppercase mb-10" style={{ color: '#9E9E9E' }}>Total Segments</p>
      <p className="fsz-19 bold-800 mb-10">{usage.region.aggregateStats.totalSegments}</p>
      <p className="fsz-11 bold-800 uppercase mb-10" style={{ color: '#9E9E9E' }}>Balance Used</p>
      <p className="fsz-19 bold-800">
        $
        {usage.region.aggregateStats.totalBalance}
      </p>
    </div>
  );
};
